import React from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '@/ui/components/shared/Button';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useCartStore } from '@/ui/store/cart';
import { paths } from '@/constants/paths';
import { useLocaleLink } from '@/ui/hooks/useLocaleLink';

export function CartCheckoutButton({
  onClick,
  href,
  disabled,
  className,
}: {
  onClick?: () => void;
  href?: string;
  disabled: boolean;
  className?: string;
}) {
  const t = useTranslations('CartCheckoutButton');
  const router = useRouter();
  const { toggleCartDisplay } = useCartStore();
  const { localizedLink } = useLocaleLink();

  return (
    <Button
      onClick={() => {
        toggleCartDisplay();
        router.push(localizedLink(paths.checkout));
        if (onClick) {
          onClick();
        }
      }}
      href={href}
      className={twMerge('w-full px-4 text-center', className)}
      disabled={disabled}
    >
      {t('CHECK OUT')}
    </Button>
  );
}
